import { useMutation } from '@tanstack/react-query';
import { handleErrors } from '../../utils/errors';
import SharedDialog from '../../shared/shared-dialog';
import { useStore } from '../state/zustand-store';
import { useAnalytics } from '../../shared/analytics/create-events';
import * as analytics from '../../shared/analytics/analytics.json';
import { ModuleList } from '../../shared/analytics/module-list';
import { saveLicenseCountWarningMessageForBulk } from '../../api/billing-api';
import { AbstractCurrentSubscriptionModel } from '../../api/billing-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
interface BulkAddLicensesDialogProps {
  open: boolean;
  handleClose: () => void;
  subscription: AbstractCurrentSubscriptionModel;
  additonalLicenseCount: number;
}

export default function BulkAddLicensesDialog({
  open,
  handleClose,
  subscription,
  additonalLicenseCount,
}: BulkAddLicensesDialogProps) {
  const { createEvent } = useAnalytics();
  const { setSnackbar } = useStore();

  const { mutate, isPending } = useMutation({
    mutationFn: () =>
      saveLicenseCountWarningMessageForBulk(
        subscription.productModel.productName,
        subscription.totalPurchasedLicenses,
        additonalLicenseCount
      ),
    onSuccess: () => {
      setSnackbar({
        open: true,
        severity: 'success',
        message: 'Ticket created successfully!',
      });
      handleClose();
    },
    onError: (error) => {
      handleErrors({
        error,
        snackbarMessage:
          'There was an issue creating the ticket. Please refresh and try again.',
      });
    },
    onSettled: () => {
      createEvent(
        analytics.billing.subscriptions.create_bulk_add_licenses_ticket,
        {
          module: ModuleList.modules.billing.name,
          section: ModuleList.modules.billing.sections.subscriptions,
        }
      );
    },
  });

  return (
    <SharedDialog
      open={open}
      handleClose={handleClose}
      title="Bulk Add Licenses"
      dialogContent={
        <Box>
          <Typography>
            We've detected an increase of over 50 users, and are unable to
            process your request. To create a ticket with sales to purchase{' '}
            {additonalLicenseCount} licenses please press 'Okay'. Otherwise,
            enter a smaller amount.
          </Typography>
        </Box>
      }
      primaryButton={{
        loading: isPending,
        action: () => mutate(),
        disabled: isPending,
        title: 'Okay',
      }}
    />
  );
}
